import Box from '@mui/material/Box';
import { Theme, SxProps } from '@mui/material/styles';
import TablePagination, { TablePaginationProps } from '@mui/material/TablePagination';

// ----------------------------------------------------------------------

type Props = {
  sx?: SxProps<Theme>;
  size?: 'small' | 'medium';
};

export default function TablePaginationCustom({
  rowsPerPageOptions = [5, 10, 25],
  sx,
  size = 'small',
  ...other
}: Props & TablePaginationProps) {
  if (!other.count) {
    return null;
  }

  return (
    <Box sx={{ position: 'relative', ...sx }}>
      <TablePagination
        size={size}
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        {...other}
        page={other.page - 1}
        onPageChange={(e, newPage) => other.onPageChange(e, newPage + 1)}
        sx={{
          borderTopColor: 'transparent',
        }}
        labelRowsPerPage="แถวต่อหน้า"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} ของ ${count !== -1 ? count : `มากกว่า ${to}`}`
        }
      />
    </Box>
  );
}
